import React from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import AppLogin from './AppLogin';
import AppInfo from './AppInfo';
import AppPasswordReset from './AppPasswordReset';
import AppPasswordChange from './AppPasswordChange';
import { SessionContext, getSessionCookie } from './session';
import { getUrlParams } from './util';

import AppAdminHome from './AppAdminHome';
import AppReviewHome from './AppReviewHome';
import AppViewHome from './AppViewHome';

import DocAdminHome from './DocAdminHome';
import DocReviewHome from './DocReviewHome';
import DocViewHome from './DocViewHome';
import AdhocHome from './AdhocHome';

const App = () => {
  let params = getUrlParams(window.location.search);
  // console.log('App params', params);
  let session = getSessionCookie({ userId:params.user });
  return (
    <SessionContext.Provider value={session}>
      <Router>
        <Switch>
          <Redirect exact from="/" to="/info" />
          <Route path="/login">
            <AppLogin />
          </Route>
          <Route path="/info">
            <AppInfo />
          </Route>
          <Route path="/user/password/reset">
            <AppPasswordReset />
          </Route>
          <Route path="/user/password/change">
            <AppPasswordChange />
          </Route>
          
          <PrivateRoute path="/admin">
            <AppAdminHome />
          </PrivateRoute>
          <PrivateRoute path="/review">
            <AppReviewHome />
          </PrivateRoute>
          <Route path="/view">
            <AppViewHome />
          </Route>
          <Route path="/admin8848">
            <AppAdminHome />
          </Route>
          <Route path="/review8848">
            <AppReviewHome />
          </Route>
          
          <PrivateRoute path="/docadmin">
            <DocAdminHome />
          </PrivateRoute>
          <PrivateRoute path="/docreview">
            <DocReviewHome />
          </PrivateRoute>
          <Route path="/docview">
            <DocViewHome />
          </Route>
          <Route path="/docadmin8848">
            <DocAdminHome />
          </Route>
          <Route path="/docreview8848">
            <DocReviewHome />
          </Route>
          
          <PrivateRoute path="/adhoc">
            <AdhocHome />
          </PrivateRoute>
          <PrivateRoute path="/adhocrequest">
            <AdhocHome />
          </PrivateRoute>
          <Route path="/adhoc8848">
            <AdhocHome />
          </Route>
          <Route path="/adhocrequest8848">
            <AdhocHome />
          </Route>
        </Switch>
      </Router>
    </SessionContext.Provider>
  );
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
  let params = getUrlParams(window.location.search);
  // console.log('PrivateRoute params', params);
  let session = getSessionCookie({ userId:params.user });
  return (
    <Route
      {...rest}
      render={({ location }) => 
        (session.username) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }} />
        )
      }
    />
  );
}

const mapState = state => ({
  // userInfo: state.userInfo,
})

const mapDispatch = dispatch => ({
  // sendCode: (data) => dispatch(submitCodeRequest(data)),
  // startGetUserInfo: (data) => dispatch(getUserInfo(data)),
})

export default connect(mapState, mapDispatch)(App);

